import { ca } from '@cian/analytics';
import { Button } from '@cian/ui-kit/button';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useCalendarLifecycle } from 'shared/hooks/useCalendarLifecycle';
import { selectOfferId } from 'shared/selectors';

const trackOnlineBookingCheckDatesButtonClick = (cianId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentButton',
    action: 'Click',
    label: 'ToCalendarCheckDates',
    page: {
      pageType: 'Card',
    },
    products: [{ id: cianId }],
  });
};

export const OnlineBookingCheckDatesButtonContainer = () => {
  const offerId = useSelector(selectOfferId);
  const { openCalendar, closeCalendar, isBusy, isOpen } = useCalendarLifecycle();

  const handleClick = React.useCallback(() => {
    if (isBusy) {
      return;
    }

    if (!isOpen) {
      openCalendar();
      trackOnlineBookingCheckDatesButtonClick(offerId);

      return;
    }

    closeCalendar();
  }, [isOpen, isBusy, offerId, openCalendar, closeCalendar]);

  return (
    <Button onClick={handleClick} theme="fill_primary" size="M" fullWidth loading={isBusy}>
      Проверить даты
    </Button>
  );
};
